import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Foundation.css';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';

function Foundation() {
  const location = useLocation()
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // This will make it jump to the top without smooth scrolling
    });
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Foundation Page' });
  }, []);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Foundation</title>
      </Helmet>
      <div className="blog-container">
        <h1 className="blog-header">Welcome to our Program for Foundations and Trusts!
        </h1>
        <p className="blog-text">At Blue Plant Ecosystem, we believe in creating a greener, more sustainable future for the
          planet. With our environmentally friendly tree planting program, corporate partners now have an effective
          means to engage their workers in a meaningful way with tools that positively impact the environment.
        </p>
        <img src="/img/img/service-6.jpg" alt="" className="blog-img" />
        <h2 className="blog-highlight">Our Program Highlights:
        </h2>
        <div className="blog-section">
          <h5>Mission Statement:
          </h5>
          <p className="blog-text">Clearly defined goals and objectives focused on the conservation and sustainable
            management of marine ecosystems.
          </p>
        </div>
        <p className="blog-text" style={{color: 'green'}}>
        </p><h5>Research and Monitoring:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Funding and support for scientific research to better understand
          marine ecosystems, including biodiversity, climate impacts, and sustainable fishing practices.
        </p>
        <h5>Conservation Initiatives:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Implementation of conservation projects, such as the establishment of
          marine protected areas, habitat restoration, and efforts to combat pollution.
        </p>
        <h5>Education and Outreach:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Public awareness campaigns to educate communities about the importance
          of the blue planet ecosystem and the role individuals can play in its preservation.
        </p>
        <h5>Partnerships:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Collaboration with governmental bodies, NGOs, research institutions,
          and other stakeholders to maximize impact and resources.
        </p>
        <h5>Policy Advocacy:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Engaging in advocacy efforts to influence policies that promote
          sustainable fishing, reduce pollution, and protect marine habitats.
        </p>
        <h5>Innovation and Technology:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Investing in and promoting the development of innovative technologies
          for sustainable fisheries, ocean clean-up, and monitoring systems.
        </p>
        <h5>Legal Framework:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Establishing a legal trust structure with a clear mandate to manage
          and protect assets for the long-term benefit of the blue planet ecosystem.
        </p>
        <h5>Asset Management:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Responsible management of financial resources to ensure the trust's
          sustainability and continuous support for conservation efforts.
        </p>
        <h5>Grant Programs:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Providing grants to organizations, researchers, and projects aligned
          with the trust's mission to enhance the impact on marine conservation.
        </p>
        <h5>Endowment Building:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Creating an endowment fund to generate consistent income for ongoing
          support, ensuring the trust's longevity.
        </p>
        <h5>Transparency and Accountability:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Maintaining transparent financial reporting and accountability
          mechanisms to build trust with stakeholders and the public.
        </p>
        <h5>Adaptability:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Building flexibility into the trust's structure to adapt to changing
          environmental conditions and emerging conservation priorities.
        </p>
        <p className="blog-text" style={{color: 'green'}}>
          By incorporating these key features, a foundation and trust dedicated to the blue planet ecosystem can
          contribute significantly to the conservation and sustainable management of marine environments.
        </p>
      </div>
      <Link className="btn btn-primary btn-lg" to="/site/signup" id='btn-signup'>Sign Up</Link>
    </div>
  );
}

export default Foundation;